import { sync } from 'vuex-router-sync'
import { newVue } from '@/config/vue'
import store from '@/config/vuex'
import router from './router'
import App from './App.vue'

sync(store, router)

const init = () => {
  newVue({
    router,
    render: h => h(App),
    mount: '.js-spa',
  })
}

On.VueInit({
  init({ isSpa }) {
    if (isSpa) init()
  },
})
